import { postService, patchService, deleteService } from "../../axios/services";
import {
  buildPlanningChapterAddendumPayload,
  buildPlanningEpisodeAddendumPayload,
  buildEditChapterAddendumPayload,
  buildEditEpisodeAddendumPayload,
  buildChapterAddendumAssociationsPayload,
  buildEpisodeAddendumAssociationsPayload,
} from "./addendum.builder";

export function postPlanningEpisodeAddendum({
  blockId,
  chapterId,
  chapterAttachmentId,
  attachment,
}) {
  const payload = buildPlanningEpisodeAddendumPayload(attachment);

  return postService({
    endpoint: `Planning/episode/addenda`,
    postData: payload,
    api: "v2",
  });
}

export function postPlanningChapterAddendum({
  blockId,
  chapterId,
  chapterAttachmentId,
  attachment,
}) {
  const payload = buildPlanningChapterAddendumPayload(attachment);

  return postService({
    endpoint: `Planning/chapter/addenda`,
    postData: payload,
    api: "v2",
  });
}

export function editChapterAddendum({ addendumId, attachment }) {
  const payload = buildEditChapterAddendumPayload(attachment);

  return patchService({
    endpoint: `Planning/chapter/addenda/${addendumId}`,
    patchData: payload,
    api: "v2",
  });
}

export function editEpisodeAddendum({ addendumId, attachment }) {
  const payload = buildEditEpisodeAddendumPayload(attachment);

  return patchService({
    endpoint: `Planning/episode/addenda/${addendumId}`,
    patchData: payload,
    api: "v2",
  });
}

export function deletePlanningEpisodeAddendum({ attachmentId }) {
  return deleteService({
    endpoint: `Planning/episode/addenda/${attachmentId}`,
    api: "v2",
  });
}

export function deletePlanningChapterAddendum({ attachmentId }) {
  return deleteService({
    endpoint: `Planning/chapter/addenda/${attachmentId}`,
    api: "v2",
  });
}

export function getChapterAddendumAssociations({ addendumIds }) {
  const payload = buildChapterAddendumAssociationsPayload(addendumIds);

  return postService({
    endpoint: `Planning/chapter/addenda/lookup`,
    postData: payload,
    api: "v2",
  });
}

export function getEpisodeAddendumAssociations({ addendumIds }) {
  const payload = buildEpisodeAddendumAssociationsPayload(addendumIds);

  return postService({
    endpoint: `Planning/episode/addenda/lookup`,
    postData: payload,
    api: "v2",
  });
}
